// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 200 200%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27n%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.85%27 numOctaves=%273%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23n%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  position: relative;
  min-height: 100svh;
  display: grid;
  align-items: end;
  overflow: hidden;
  color: #fff;
}

.hero__media {
  position: absolute;
  inset: 0;
}

.hero__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 35%;
  animation: drift 18s ease-out both;
}

.hero__shade {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(180deg, rgba(8, 24, 18, 0.45) 0%, rgba(8, 24, 18, 0.28) 35%, rgba(8, 24, 18, 0.78) 100%),
    linear-gradient(90deg, rgba(8, 24, 18, 0.55) 0%, transparent 55%);
}

.hero__grain {
  position: absolute;
  inset: 0;
  opacity: 0.18;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  pointer-events: none;
  mix-blend-mode: soft-light;
}

.hero__content {
  position: relative;
  z-index: 1;
  width: var(--wide);
  margin: 0 auto;
  padding: 7.5rem 0 4.5rem;
}

.hero__brand {
  display: flex;
  align-items: center;
  gap: clamp(0.75rem, 2vw, 1.25rem);
  animation: rise 0.8s ease both;
}

.hero__mark .logo__mark {
  width: clamp(2.75rem, 7vw, 4.5rem);
  height: clamp(2.75rem, 7vw, 4.5rem);
}

.hero__name {
  font-family: var(--font-display);
  font-size: clamp(2.1rem, 6.5vw, 4.4rem);
  font-weight: 700;
  line-height: 1.05;
  letter-spacing: -0.02em;
}

.hero__title {
  max-width: 14ch;
  margin-top: 1.1rem;
  font-family: var(--font-display);
  font-size: clamp(1.55rem, 3.6vw, 2.45rem);
  font-weight: 500;
  line-height: 1.15;
  letter-spacing: -0.03em;
  animation: rise 0.8s ease 0.12s both;
}

.hero__text {
  max-width: 36ch;
  margin-top: 1rem;
  font-size: 1.08rem;
  color: rgba(255, 255, 255, 0.86);
  animation: rise 0.8s ease 0.22s both;
}

.hero__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1.75rem;
  animation: rise 0.8s ease 0.32s both;
}

@media (max-width: 640px) {
  .hero__content {
    padding-bottom: 3.25rem;
  }

  .hero__actions {
    flex-direction: column;
    align-items: stretch;
  }

  .hero__actions .btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Hero.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;qEAEmE;AACrE;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,yDAAqT;EACrT,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".hero {\r\n  position: relative;\r\n  min-height: 100svh;\r\n  display: grid;\r\n  align-items: end;\r\n  overflow: hidden;\r\n  color: #fff;\r\n}\r\n\r\n.hero__media {\r\n  position: absolute;\r\n  inset: 0;\r\n}\r\n\r\n.hero__image {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  object-position: center 35%;\r\n  animation: drift 18s ease-out both;\r\n}\r\n\r\n.hero__shade {\r\n  position: absolute;\r\n  inset: 0;\r\n  background:\r\n    linear-gradient(180deg, rgba(8, 24, 18, 0.45) 0%, rgba(8, 24, 18, 0.28) 35%, rgba(8, 24, 18, 0.78) 100%),\r\n    linear-gradient(90deg, rgba(8, 24, 18, 0.55) 0%, transparent 55%);\r\n}\r\n\r\n.hero__grain {\r\n  position: absolute;\r\n  inset: 0;\r\n  opacity: 0.18;\r\n  background-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\");\r\n  pointer-events: none;\r\n  mix-blend-mode: soft-light;\r\n}\r\n\r\n.hero__content {\r\n  position: relative;\r\n  z-index: 1;\r\n  width: var(--wide);\r\n  margin: 0 auto;\r\n  padding: 7.5rem 0 4.5rem;\r\n}\r\n\r\n.hero__brand {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: clamp(0.75rem, 2vw, 1.25rem);\r\n  animation: rise 0.8s ease both;\r\n}\r\n\r\n.hero__mark .logo__mark {\r\n  width: clamp(2.75rem, 7vw, 4.5rem);\r\n  height: clamp(2.75rem, 7vw, 4.5rem);\r\n}\r\n\r\n.hero__name {\r\n  font-family: var(--font-display);\r\n  font-size: clamp(2.1rem, 6.5vw, 4.4rem);\r\n  font-weight: 700;\r\n  line-height: 1.05;\r\n  letter-spacing: -0.02em;\r\n}\r\n\r\n.hero__title {\r\n  max-width: 14ch;\r\n  margin-top: 1.1rem;\r\n  font-family: var(--font-display);\r\n  font-size: clamp(1.55rem, 3.6vw, 2.45rem);\r\n  font-weight: 500;\r\n  line-height: 1.15;\r\n  letter-spacing: -0.03em;\r\n  animation: rise 0.8s ease 0.12s both;\r\n}\r\n\r\n.hero__text {\r\n  max-width: 36ch;\r\n  margin-top: 1rem;\r\n  font-size: 1.08rem;\r\n  color: rgba(255, 255, 255, 0.86);\r\n  animation: rise 0.8s ease 0.22s both;\r\n}\r\n\r\n.hero__actions {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.75rem;\r\n  margin-top: 1.75rem;\r\n  animation: rise 0.8s ease 0.32s both;\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .hero__content {\r\n    padding-bottom: 3.25rem;\r\n  }\r\n\r\n  .hero__actions {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .hero__actions .btn {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
